enum ChatVoiceError {
  BLOCKED = "blocked", //     permission refused, or previously blocked for the site
  NO_DEVICE = "noDevice", //  no input device available
  STOPPED = "stopped", //     capture died mid-session — the track ended or the recorder failed
  UNKNOWN = "unknown", //     anything else; logged, never blamed on the rep
}

export default ChatVoiceError;
